<template>
  <div class="contain">
    <!-- 订单状态 -->
    <van-sticky>
      <van-tabs @click="getState" v-model="status">
        <van-tab
          v-for="(item, index) in tabList"
          :title="item.name"
          :key="index"
        >
        </van-tab>
      </van-tabs>
    </van-sticky>
    <!-- 订单列表 -->
    <div class="box">
      <van-list
        v-model="loading"
        offset="10"
        :finished="finished"
        finished-text="没有更多了 ~"
        @load="onLoad"
        :immediate-check="false"
      >
        <div v-for="(item, index) in List" :key="index">
          <div class="mid">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
              "
            >
              <div class="title" v-if="item.status == 1">待抢单</div>
              <div class="title" v-if="item.status == 2">抢单成功</div>
              <div class="title" v-if="item.status == 3">已成单</div>
              <div class="title" v-if="item.status == 4">已完成</div>
              <span
                style="
                  font-family: Price;
                  font-weight: 500;
                  font-size: 20px;
                  color: #f36e86;
                "
              >
                <span style="font-size: 12px">￥</span
                >{{ item.price.toFixed(2) }}
              </span>
            </div>
            <div class="li" @click="gotoXq(item)">
              <div class="nickName" style="font-size: 16px">
                <span>{{ item.name }}</span>
                <span style="font-size: 13px; color: #666">{{
                  item.create_time
                }}</span>
              </div>
              <div
                v-if="item.content"
                class="content van-ellipsis--l2"
                v-html="item.content"
              ></div>
            </div>
            <!-- -->
            <button
              v-if="item.status == 3 && item.isShow == 1"
              class="grabbing"
              @click="handlePay(item)"
            >
              支付
            </button>
            <button
              v-if="item.status == 3 && item.isShow == 0"
              class="grabbing"
              style="background-color: #f7f7f7; border-color: #eee; color: #666"
              @click="handlePay1()"
            >
              等待对方支付
            </button>
            <button
              v-if="item.status == 4 && item.isComment == 0 && item.isShow == 1"
              class="grabbing"
              @click="evaluate(item)"
            >
              评价
            </button>
          </div>
          <!-- <van-card
            v-for="(j, k) in item.detail"
            :key="k"
            :num="j.buyNumber"
            :price="j.buyIntegral + '积分'"
            :title="j.goodsName"
            :thumb="j.goodsImg"
            :desc="item.remark"
          >
            <template #tags>
              <van-tag type="primary" v-if="item.status == 1">已下单</van-tag>
              <van-tag type="warning" v-if="item.status == 2">待取货</van-tag>
              <van-tag type="success" v-if="item.status == 3">已完成</van-tag>
              <van-tag type="danger" v-if="item.status == 4">已取消</van-tag>
            </template>
            <template #footer>
              <van-button
                size="small"
                @click="cancel(item)"
                v-if="userType == item.userId && item.status == 1"
                >取消订单</van-button
              >
              <van-button
                size="small"
                type="info"
                v-if="storeType == item.storeId && item.status == 1"
                @click="receive(item.id)"
                >接单</van-button
              >
              <van-button
                type="warning"
                size="small"
                v-if="userType == item.userId && item.status == 2"
                @click="pickUp(item)"
                >取货</van-button
              >
            </template>
          </van-card> -->
        </div>
      </van-list>
      <!-- <div class="fixed">
        <button class="bottomBtn" @click="evaluateList">我的评价</button>
      </div> -->
      <!-- 空状态 -->
      <!-- <van-empty v-if="List.length == 0" description="暂无数据" /> -->
    </div>
  </div>
</template>
  
  <script>
import { getDemandList } from "@/api/demand";
import { getOpenId, getPlatform, getStoreId, getUrl } from "@/utils/auth";
import { Toast, Dialog } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      tabList: [
        {
          id: "",
          name: "全部",
        },
        {
          id: 1,
          name: "待抢单",
        },
        {
          id: 2,
          name: "抢单成功",
        },
        {
          id: 3,
          name: "已成单",
        },
        {
          id: 4,
          name: "已完成",
        },
      ],
      status: "",
      List: [],
      storeType: "",
      page: 1,
      url: "",
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 支付
    handlePay(row) {
      console.log(row);
      var toUserId = "";
      if (row.tradeType == 1) {
        row.grabbing.forEach((i) => {
          if (i.status == 2 && i.userType == 1) {
            toUserId = 0;
          } else if (i.status == 2 && i.userType == 2) {
            toUserId = i.userId;
          }
        });
      } else {
        if (row.userType == 1) {
          toUserId = 0;
        } else {
          toUserId = row.userId;
        }
      }
      // 跳转到 小程序 调用pay 方法
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url:
            "../public/pay?id=" +
            row.id +
            "&userId=" +
            getOpenId() +
            "&toUserId=" +
            toUserId,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    handlePay1() {
      Toast("请耐心等待购买方支付");
    },
    // 需求详情
    gotoXq(row) {
      this.gotoUrl("/demand/orderDetail/" + row.id);
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.page = this.page + 1;
      this.getOrderList(undefined);
    },
    getState(name, tab) {
      console.log(name, tab);
      this.loading = true;
      this.finished = false;
      this.List = [];
      this.page = 1;
      this.status = name;
      this.getOrderList();
    },
    // 获取订单列表
    getOrderList() {
      var grabbingId = "";
      if (getStoreId() && getStoreId() != "null") {
        grabbingId = getStoreId();
      } else {
        grabbingId = getOpenId();
      }
      var str = getUrl();
      this.url = getUrl().slice(0, str.length - 1);
      this.loading = true;
      console.log(this.loading);
      getDemandList({
        // userId: getOpenId(),
        grabbingId: grabbingId,
        status: this.status,
        pageSize: 10,
        pageNum: this.page,
        platformId: getPlatform(),
        url: this.url,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.List = this.List.concat(rows);
          console.log(this.List);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },

    // 取消订单
    cancel(item) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定要取消该订单吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: item.id, status: 4 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              this.addUserIntegral(item.totalMoney);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 取货
    pickUp(item) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确认已收到货了吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: item.id, status: 3 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              this.updUserIntegral(item);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 评价
    evaluate(item) {
      console.log(item);
      var id = "";
      item.grabbing.forEach((i) => {
        if (i.status == 3) {
          id = i.id;
        }
      });
      this.gotoUrl(
        "/demand/evaluate/" +
          id +
          "/" +
          item.id +
          "/" +
          item.userId +
          "/" +
          item.userType
      );
    },

    // 我的评价 列表
    evaluateList() {
      this.gotoUrl("/hotels/evaluateList/1");
    },
    // 修改对应项目 积分
    updUserIntegral(item) {
      console.log(item.totalMoney, "totalMoney");
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/updStoreIntegral";
      const params = { storeId: item.storeId, integral: item.totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          Toast.success("取货成功");
          this.List = [];
          that.getOrderList();
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },

    // 修改对应项目 积分
    addUserIntegral(totalMoney) {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/addUserIntegral";
      const params = { userId: getOpenId(), integral: totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          Toast.success("取消成功");
          this.List = [];
          that.getOrderList();
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
  },
  created() {
    this.getOrderList();
    this.storeType = getStoreId();
    this.userType = getOpenId();
  },
  mounted() {},
};
</script> 
  
  <style scoped>
@font-face {
  font-family: "Price";
  src: url(../../assets/font/OPPOSANS-H.TTF);
}
.contain {
  background: #f7f7f7;
  min-height: 100vh;
}
/deep/ .van-tabs__nav {
  background: #f7f7f7;
}
/deep/ .van-tab {
  font-size: 14px;
  font-family: PingFang SC;
}

/deep/ .van-tabs__line {
  border-radius: 3px !important;
  background-color: #f36e86;
}

.box {
  padding: 10px 10px;
}

/deep/ .van-button {
  border-radius: 8px;
  width: 66px;
  /* padding: 0 16px; */
}

/deep/ .van-list {
  padding-bottom: 100px;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.08);
  z-index: 100;
  text-align: center;
}

.bottomBtn {
  background: #f36e86;
  border-radius: 22px;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
  width: 94%;
  padding: 11.5px 0;
  margin-top: 7.5px;
}

/deep/ .van-tag {
  position: absolute;
  right: -16px;
  top: -8px;
  padding: 0px 4px;
  font-size: 8px;
  border-radius: 0 8px 0 8px;
}

.card {
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 8px;
}

.code {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}

.mid {
  width: 100%;
  margin: auto;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 14px 16px 7px;
}

.title {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 15px;
  color: #232323;
}

.li {
  width: 100%;
  background: #f7f7f7;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 14px 12px 12px;
  position: relative;
}

.nickName {
  display: flex;
  justify-content: space-between;
  align-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #1e1e1e;
}
.content {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}
.van-ellipsis--l2 {
  display: -webkit-box !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}
.grabbing {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #f36e8629;
  border-radius: 17px;
  border: none;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 13px;
  color: #f36e86;
  margin-top: 15px;
  border: 1px solid #f36e86;
}
</style>